"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Box = require("../Box");

var _Box2 = _interopRequireDefault(_Box);

var _recharts = require("recharts");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const getRandomColor = () => Math.floor(Math.random() * 16777215).toString(16);

const LineCharts = ({ data, xAxis, yAxises }) => {
  const Colors = data.map(() => `#${getRandomColor()}`);

  return _react2.default.createElement(
    _Box2.default,
    null,
    _react2.default.createElement(
      _recharts.LineChart,
      {
        width: 730,
        height: 250,
        data: data,
        margin: { top: 5, right: 30, left: 20, bottom: 5 }
      },
      _react2.default.createElement(_recharts.CartesianGrid, { strokeDasharray: "3 3" }),
      _react2.default.createElement(_recharts.XAxis, { dataKey: xAxis }),
      _react2.default.createElement(_recharts.YAxis, null),
      _react2.default.createElement(_recharts.Tooltip, null),
      _react2.default.createElement(_recharts.Legend, null),
      yAxises.map((y, index) => _react2.default.createElement(_recharts.Line, { type: "monotone", dataKey: y, stroke: Colors[index] }))
    )
  );
};

exports.default = LineCharts;